import { createAction } from '@wix/communities-blog-client-common';

export const POST_PAGE_SOCIAL_SHARE_CLICKED = 'postPageSocialShare/CLICKED';

export const postPageSocialShareClicked = createAction(
  POST_PAGE_SOCIAL_SHARE_CLICKED,
);
